import { ErrorHandler } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from "@angular/common/http";
import { EcosystemMonitorComponent } from "./app/ecosystem-monitor.component";
import { getEnv } from "./app/environment";
import {
  ConsoleErrorHandler,
  reportFailedRequests,
  startErrorReporting,
} from "./app/error-reporting";

// Started first, so that errors during bootstrap are reported too.
startErrorReporting("transparency-watch", getEnv().faroUrl).then(() =>
  bootstrapApplication(EcosystemMonitorComponent, {
    providers: [
      { provide: ErrorHandler, useClass: ConsoleErrorHandler },
      provideHttpClient(withFetch(), withInterceptors([reportFailedRequests])),
    ],
  }).catch((error) => console.error(error)),
);
